<template>
    <div class="pageTitleArea animated">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="pageTitle">
                        <div class="h2">{{ title }}</div>
                        <ul class="pageIndicate">
                            <li><a href="/"><i class="fa fa-home"></i> </a></li>
                            <li><a href="">{{ sluggedTitle }}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import slugify from 'slugify'

export default {
  name: 'quick-site-bread-crumb',
  props: ['title'],
  computed: {
    sluggedTitle: function () {
      return slugify(this.title)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/site/SiteBreadCrumb.vue